
import { Component, Prop, Vue } from "vue-property-decorator";
@Component({})
export default class BtnRadio extends Vue {
  @Prop({ default: () => [], type: Array })
  options: any;
  @Prop({ default: false, type: Boolean })
  space: boolean;
  @Prop({ default: false, type: Boolean }) // 是否拉伸至父元素宽度
  full: boolean;
}
